export default {
    email: null,
    code: null,
    status: "unauthorized",
    errorMsg: "An error ocurred, please try again"
}